<script setup lang="ts">
  import CheckboxQC from '@qicgroupdoha/qic-connect-ds/components/CheckboxQC'
  import LinkQC from '@qicgroupdoha/qic-connect-ds/components/LinkQC'
  import { useLinkTarget } from '@/shared/composables/useLinkTarget'

  interface Props {
    termsHref: string
    acceptanceError: boolean
  }

  defineProps<Props>()

  const emit = defineEmits<{
    (e: 'click-link'): void
  }>()

  const acceptance = defineModel<boolean>({ required: true })

  const { getLinkTarget } = useLinkTarget()
</script>

<template>
  <label class="quote__terms" data-test="quote-acceptance-checkbox-label">
    <CheckboxQC
      id="acceptCheck"
      v-model="acceptance"
      name="acceptCheck"
      :error="acceptanceError"
      :container-attrs="{ 'data-test': 'quote-acceptance-checkbox' }"
      data-test="quote-acceptance-checkbox-inner"
    >
      <span>
        {{ $t('qic_quote_acceptance_before_link') }}
        <LinkQC
          :href="termsHref"
          :target="getLinkTarget()"
          data-test="quote-acceptance-link"
          @click="emit('click-link')"
        >
          {{ $t('qic_quote_acceptance_link') }}
        </LinkQC>
      </span>
    </CheckboxQC>
  </label>
</template>
